<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :btnRefreshVisible="true" :btnNewVisible="false" :linkConfigurazioni="linkConfigurazione" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template #toolbar>
            <b-button class="button-new" size="sm" variant="success btn-toolbar float-sm-right sa-margin-right" @click="onNew">
                <b-icon icon="plus"></b-icon>
                {{ $t("global.lblBtnNew") }}
            </b-button>
        </template>
        <template #table-filter>
            <div class="sa-list-component-header" style="padding-top: 5px">
                <div class="sa-page-search-component">
                    <b-form style="width: 100%" @submit.prevent="onSubmit">
                        <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Tipo</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroConfigurazioneDevice.tipo" placeholder="Inserisci tipo device.." />
                                </div>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Imei</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroConfigurazioneDevice.imeii" placeholder="Inserisci imei device.." />
                                </div>
                            </b-col>

                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Stato Attuale</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroConfigurazioneDevice.statoAttuale" placeholder="Inserisci stato attuale device.." />
                                </div>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Sistema Operativo</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroConfigurazioneDevice.sistemaOperativo" placeholder="Inserisci sistema operativo.." />
                                    <button class="sa-page-search-component-btn-search" title="Search">
                                        <i class="fas fa-search"></i>
                                    </button>
                                    <button class="sa-page-search-component-btn-reset" @click="resetFiltriConfigurazioneDevice" type="button"><i class="fas fa-trash"></i></button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </div>
        </template>
        <template slot="table-body">
            <configurazione-device-device-list-component ref="ConfigurazioneDeviceListComponent" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData"></configurazione-device-device-list-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneDeviceDeviceListComponent from "../components/ConfigurazioneDeviceDeviceListComponent.vue";

export default {
    components: { SaPageLayout, ConfigurazioneDeviceDeviceListComponent },

    data() {
        return {
            linkConfigurazione: "/configurazionedevice",
            pathResource: "/devicedevice",
            showModalLoading: false,
            filtroConfigurazioneDevice: {
                tipo: null,
                imeii: null,
                statoAttuale: null,
                sistemaOperativo: null,
            },
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        me.showModalLoading = true;
        let filtroConfigurazioneDevice = sessionStorage.getItem("filtroConfigurazioneDevice");
        if (filtroConfigurazioneDevice) {
            me.filtroConfigurazioneDevice = JSON.parse(filtroConfigurazioneDevice);
        }
        me.loadData(me.filtroConfigurazioneDevice);
    },
    methods: {
        loadData(filtro) {
            let me = this;
            me.onBeforeLoadData();
            me.$refs.ConfigurazioneDeviceListComponent.loadData(filtro);
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroConfigurazioneDevice = sessionStorage.getItem("filtroConfigurazioneDevice");
            if (filtroConfigurazioneDevice) {
                me.filtroConfigurazioneDevice = JSON.parse(filtroConfigurazioneDevice);
            }
            me.loadData(me.filtroConfigurazioneDevice);
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        resetFiltriConfigurazioneDevice() {
            let me = this;
            me.filtroConfigurazioneDevice = {
                tipo: null,
                imeii: null,
                statoAttuale: null,
                sistemaOperativo: null,
            };
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroConfigurazioneDevice", JSON.stringify(me.filtroConfigurazioneDevice));
            this.$refs.ConfigurazioneDeviceListComponent.loadData();
        },
        onNew() {
            this.$refs.ConfigurazioneDeviceListComponent.onEdit({ id: "-1", imeii: "", sistemaOperativo: "", tipo: "", statoAttuale: "", password: "" });
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroConfigurazioneDevice", JSON.stringify(me.filtroConfigurazioneDevice));
            me.$refs.ConfigurazioneDeviceListComponent.loadData(me.filtroConfigurazioneDevice);
        },
    },
};
</script>
<style scoped>
.button-new {
    border: 1px solid #218838;
}
</style>
